// Type's
export const TIMEINITIATIVE_GET_ALL_REQUEST = 'TIMEINITIATIVE_GET_ALL_REQUEST'
export const TIMEINITIATIVE_GET_ALL_SUCCESS = 'TIMEINITIATIVE_GET_ALL_SUCCESS'
export const TIMEINITIATIVE_GET_ALL_FAILURE = 'TIMEINITIATIVE_GET_ALL_FAILURE'

export const TIMEINITIATIVE_CREATE_REQUEST = 'TIMEINITIATIVE_CREATE_REQUEST'
export const TIMEINITIATIVE_CREATE_SUCCESS = 'TIMEINITIATIVE_CREATE_SUCCESS'
export const TIMEINITIATIVE_CREATE_FAILURE = 'TIMEINITIATIVE_CREATE_FAILURE'

export const TIMEINITIATIVE_GET_ONE_REQUEST = 'TIMEINITIATIVE_GET_ONE_REQUEST'
export const TIMEINITIATIVE_GET_ONE_SUCCESS = 'TIMEINITIATIVE_GET_ONE_SUCCESS'
export const TIMEINITIATIVE_GET_ONE_FAILURE = 'TIMEINITIATIVE_GET_ONE_FAILURE'

export const TIMEINITIATIVE_EDIT_REQUEST = 'TIMEINITIATIVE_EDIT_REQUEST'
export const TIMEINITIATIVE_EDIT_SUCCESS = 'TIMEINITIATIVE_EDIT_SUCCESS'
export const TIMEINITIATIVE_EDIT_FAILURE = 'TIMEINITIATIVE_EDIT_FAILURE'

export const TIMEINITIATIVE_REMOVE_REQUEST = 'TIMEINITIATIVE_REMOVE_REQUEST'
export const TIMEINITIATIVE_REMOVE_SUCCESS = 'TIMEINITIATIVE_REMOVE_SUCCESS'
export const TIMEINITIATIVE_REMOVE_FAILURE = 'TIMEINITIATIVE_REMOVE_FAILURE'

export const TIMEINITIATIVE_REACTIVATE_REQUEST = 'TIMEINITIATIVE_REACTIVATE_REQUEST'
export const TIMEINITIATIVE_REACTIVATE_SUCCESS = 'TIMEINITIATIVE_REACTIVATE_SUCCESS'
export const TIMEINITIATIVE_REACTIVATE_FAILURE = 'TIMEINITIATIVE_REACTIVATE_FAILURE'

export const TIMEINITIATIVE_FILTER_CHANGE_REQUEST = 'TIMEINITIATIVE_FILTER_CHANGE_REQUEST'
export const TIMEINITIATIVE_FILTER_CHANGE_SUCCESS = 'TIMEINITIATIVE_FILTER_CHANGE_SUCCESS'
export const TIMEINITIATIVE_FILTER_CHANGE_FAILURE = 'TIMEINITIATIVE_FILTER_CHANGE_FAILURE'

export const TIMEINITIATIVE_GET_TOTALS_REQUEST = 'TIMEINITIATIVE_GET_TOTALS_REQUEST'
export const TIMEINITIATIVE_GET_TOTALS_SUCCESS = 'TIMEINITIATIVE_GET_TOTALS_SUCCESS'
export const TIMEINITIATIVE_GET_TOTALS_FAILURE = 'TIMEINITIATIVE_GET_TOTALS_FAILURE'

// Action's
export const timeInitiativeGetAllRequest = filters => ({
  type: TIMEINITIATIVE_GET_ALL_REQUEST,
  filters
})
export const timeInitiativeGetAllSuccess = payload => ({
  type: TIMEINITIATIVE_GET_ALL_SUCCESS,
  payload
})
export const postgetAllFailure = error => ({
  type: TIMEINITIATIVE_GET_ALL_REQUEST,
  error
})
export const timeInitiativeFiltersChangeRequest = filters => ({
  type: TIMEINITIATIVE_FILTER_CHANGE_REQUEST,
  filters
})
export const timeInitiativeGetOneRequest = payload => ({
  type: TIMEINITIATIVE_GET_ONE_REQUEST,
  payload
})
export const timeInitiativeGetOneSuccess = payload => ({
  type: TIMEINITIATIVE_GET_ONE_SUCCESS,
  payload
})
export const timeInitiativeGetOneFailure = payload => ({
  type: TIMEINITIATIVE_GET_ONE_FAILURE,
  payload
})
export const timeInitiativeDeactivateRequest = payload => ({
  type: TIMEINITIATIVE_REMOVE_REQUEST,
  payload
})
export const timeInitiativeReactivateRequest = payload => ({
  type: TIMEINITIATIVE_REACTIVATE_REQUEST,
  payload
})
export const timeInitiativeCreateRequest = ({ values }) => ({
  type: TIMEINITIATIVE_CREATE_REQUEST,
  payload: values
})
export const timeInitiativeEditRequest = ({ values }) => ({
  type: TIMEINITIATIVE_EDIT_REQUEST,
  payload: values
})
export const timeInitiativeCreateSuccess = payload => ({
  type: TIMEINITIATIVE_CREATE_SUCCESS,
  payload
})
export const timeInitiativeCreateFailure = payload => ({
  type: TIMEINITIATIVE_CREATE_FAILURE,
  payload
})
export const timeInitiativeGetTotals = payload => ({
  type: TIMEINITIATIVE_GET_TOTALS_REQUEST,
  payload
})

// Reducer
const INITIAL_STATE = {
  one: {},
  all: [],
  loading: false,
  error: null,
  filters: {},
  totals: {}
}

export function timeInitiatives(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TIMEINITIATIVE_GET_TOTALS_REQUEST:
    case TIMEINITIATIVE_CREATE_REQUEST:
    case TIMEINITIATIVE_GET_ALL_REQUEST:
    case TIMEINITIATIVE_GET_ONE_REQUEST:
    case TIMEINITIATIVE_REMOVE_REQUEST:
    case TIMEINITIATIVE_EDIT_REQUEST:
    case TIMEINITIATIVE_REACTIVATE_REQUEST:
      return { ...state, error: null, loading: true }

    case TIMEINITIATIVE_GET_ALL_SUCCESS:
      return { ...state, error: null, loading: false, all: { ...action.payload } }
    case TIMEINITIATIVE_CREATE_SUCCESS:
    case TIMEINITIATIVE_EDIT_SUCCESS:
      return { ...state, error: null, loading: false, one: [action.payload] }
    case TIMEINITIATIVE_GET_ONE_SUCCESS:
    case TIMEINITIATIVE_REMOVE_SUCCESS:
    case TIMEINITIATIVE_REACTIVATE_SUCCESS:
      return { ...state, error: null, loading: false, one: { ...action.payload } }
    case TIMEINITIATIVE_GET_TOTALS_SUCCESS:
      return { ...state, error: null, loading: false, totals: { ...action.payload } }

    case TIMEINITIATIVE_REMOVE_FAILURE:
    case TIMEINITIATIVE_GET_TOTALS_FAILURE:
    case TIMEINITIATIVE_GET_ALL_FAILURE:
    case TIMEINITIATIVE_EDIT_FAILURE:
    case TIMEINITIATIVE_REACTIVATE_FAILURE:
    case TIMEINITIATIVE_GET_ONE_FAILURE:
    case TIMEINITIATIVE_CREATE_FAILURE:
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
